var rowTotal = row => row.reduce((a, b) => a + b * 100, 0) / 100;
var completeRow = row => [...row.slice(0, -1), (row.slice(-1)[0] * 100 + (100 - rowTotal(row) * 100)) / 100];
export var layoutCalculation = sizes => sizes.reduce((rows, size, index) => {
  if (size > 1) {
    throw new Error('Sizes above 1 are not allowed for the elements in a Fieldset');
  }
  var currentRow = rows.slice(-1)[0];
  var currentRowTotal = rowTotal(currentRow);
  var isLast = index === sizes.length - 1;
  if (currentRowTotal + size > 1) {
    var initialRows = rows.slice(0, -1);
    var lastRow = rows.slice(-1)[0];
    return [...initialRows, completeRow(lastRow), [isLast ? 1 : size]];
  }
  var updatedRow = [...currentRow, isLast ? 1 - currentRowTotal : size];
  return [...rows.slice(0, -1), updatedRow];
}, [[]]);
export var fieldIndex = (rows, rowIndex, sizeIndex) => {
  var elementsUpUntilThisRow = rows.slice(0, rowIndex).map(row => row.length).reduce((a, b) => a + b, 0);
  return elementsUpUntilThisRow + sizeIndex;
};
export var positionInFieldset = (rows, rowIndex, sizeIndex) => {
  if (rowIndex === 0) {
    if (sizeIndex === 0) {
      if (rows.length === 1 && rows[0].length === 1) {
        return 'standalone';
      } else if (rows.length === 1) {
        return 'left';
      } else if (rows[0].length === 1) {
        return 'top';
      }
      return 'topLeft';
    } else if (sizeIndex === rows[0].length - 1) {
      if (rows.length === 1) {
        return 'right';
      }
      return 'topRight';
    }
    return 'inner';
  } else if (rowIndex === rows.length - 1) {
    if (sizeIndex === 0) {
      if (rows[rowIndex].length === 1) {
        return 'bottom';
      }
      return 'bottomLeft';
    } else if (sizeIndex === rows[rowIndex].length - 1) {
      return 'bottomRight';
    }
    return 'inner';
  } else if (sizeIndex === 0) {
    if (rows[rowIndex].length === 1) {
      return 'center';
    }
    return 'centerLeft';
  } else if (sizeIndex === rows[rowIndex].length - 1) {
    return 'centerRight';
  }
  return 'inner';
};
//# sourceMappingURL=layoutCalculation.js.map